<template>
  <div class="app-container" v-if="form">
    <!-- 头部信息 -->
    <div class="meeting-info">
      <!-- 返回按钮 -->
      <div class="back-button" @click="handleBack">
        返回列表
      </div>
      <!-- 会议信息-->
      <div class="meeting-header section-box">
        <el-image
          class="main-image"
          :src="form.imageUrl"
          :preview-src-list="[form.imageUrl]"
          fit="cover"
        ></el-image>
        <div>
          <div class="meeting-title">
            <h2>{{ form.title }}</h2>
            <div class="meeting-type">{{ form.categoryName }}</div>
          </div>
          <div class="meeting-meta">
            <div class="meta-item">创建会议人: {{ form.userRealName }}</div>
            <div class="meta-item">主讲老师: 
              <template v-if="form.lecturerList && form.lecturerList.length > 0">
                <span v-for="(lecturer, index) in form.lecturerList" :key="index">
                  {{ lecturer.realName }}<span v-if="index < form.lecturerList.length - 1">，</span>
                </span>
              </template>
              <template v-else>
                {{ form.lecturerRealName }}
              </template>
            </div>
            <div class="meta-item">省市区：{{ form.address }}</div>
          </div>
        </div>
      </div>
      <!-- 进度条 -->
      <div class="progress-section section-box">
        <div class="progress-item" :class="{ active: singState === 1 }">
          <div class="progress-dot"></div>
          <span>未开始报名</span>
          <div class="progress-time">创建时间:{{ form.createdTime }}</div>
        </div>
        <div class="progress-line" :class="{ active: singState === 2 }"></div>
        <div class="progress-item" :class="{ active: singState === 2 }">
          <div class="progress-dot"></div>
          <span>报名中</span>
          <div class="progress-time">
            <div>报名时间</div>
            {{ form.signUpStartTime }}-{{ form.signUpEndTime }}
          </div>
        </div>
        <div
          class="progress-line"
          :class="{ active: meetingState === 2 }"
        ></div>
        <div class="progress-item" :class="{ active: meetingState === 2 }">
          <div class="progress-dot"></div>
          <span>会议进行中</span>
          <div class="progress-time">
            <div>会议时间</div>
            {{ form.startTime }}-{{ form.endTime }}
          </div>
        </div>
        <div
          class="progress-line"
          :class="{ active: meetingState === 3 }"
        ></div>
        <div class="progress-item" :class="{ active: meetingState === 3 }">
          <div class="progress-dot"></div>
          <span>已结束</span>
          <div class="progress-time">{{ form.endTime }}</div>
        </div>
      </div>
    </div>
    <!-- 基础信息 -->
    <div class="info-section section-box">
      <div class="section-title">
        <span>基础信息</span>
      </div>
      <div class="section-body">
        <div class="meeting-images">
          <div class="meeting-image-title">会议图：</div>
          <div class="meeting-image-list">
            <div
              class="meeting-image-item"
              v-for="(item, index) in form.bannerUrl &&
                form.bannerUrl.split(',')"
              :key="index"
            >
              <el-image :src="item" :preview-src-list="[item]"></el-image>
            </div>
          </div>
        </div>
        <div class="info-content">
          <div class="info-item">携带人数：{{ form.maxCarryPeople }}人</div>
          <div class="info-item">
            1位成人最多携带儿童人数：{{ form.maxCarryChildPer }}人
          </div>
          <div class="info-item">签到距离：{{ form.signUpRadius }}km</div>
          <div class="info-item">
            虚拟报名人数：{{ form.signUpCountVirtual }}人
          </div>
        </div>
      </div>
    </div>
    <!-- 报名身份/费用限制 -->
    <div class="detail-section section-box">
      <div class="section-title">
        <span>报名身份/费用限制</span>
      </div>
      <div class="section-body participation-layout">
        <div class="participation-label">参与身份:</div>
        <div class="participation-content">
          <div class="participation-type" v-if="form.feeList && form.feeList.length > 0">指定身份参与</div>
          <div class="participation-type" v-else>所有人免费参与</div>
          <!-- 身份列表 -->
          <!-- <div class="identity-list" v-if="form.feeList && form.feeList.length > 0">
            <div 
              class="identity-item" 
              v-for="(item, index) in form.feeList" 
              :key="index"
            >
              <span class="identity-name">{{ item.levelName || item.nameStr }}:</span>
              <span class="identity-status" :class="{ free: item.isFree }">
                {{ item.isFree ? '免费' : '收费' }}
              </span>
            </div>
          </div> -->

          <!-- 费用表格 -->
          <div class="fee-table" v-if="form.feeList && form.feeList.length > 0">
            <div class="table-header">
              <div class="header-cell">身份</div>
              <div class="header-cell">现金收费</div>
              <div class="header-cell">入账金额</div>
              <div class="header-cell">余额收费</div>
              <div class="header-cell">零售价收费</div>
              <div class="header-cell">赠送额度收费</div>
            </div>
            <div 
              class="table-row" 
              v-for="(item, index) in form.feeList" 
              :key="index"
            >
              <div class="table-cell">{{ item.type===20?item.levelName:formateNme(item.type)}}(第{{ getPersonOrderNumber(item, index) }}人报名)</div>
              <div class="table-cell">{{ formatFee(item.amount) }}</div>
              <div class="table-cell">
                {{ item.giftAccountType===1?'余额':item.giftAccountType===2?'零售价':item.giftAccountType===3?'赠送额度':'-' }}
                  /{{ formatFee(item.giftAmount) }}
              </div>
              <div class="table-cell">{{ formatFee(item.balance) }}</div>
              <div class="table-cell">{{ formatFee(item.xiaoduCoin) }}</div>
              <div class="table-cell">{{ formatFee(item.giftAmount) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 会议详情 -->
    <div class="detail-section section-box">
      <div class="section-title">
        <span>会议详情</span>
      </div>
      <div class="section-body">
        <div class="meeting-detail-content" v-html="form.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import meetingSignUpApi from "@/api/meeting/meetingSignUp";
import { getTimeStatus } from "@/utils/index";
export default {
  props: ["rowItem"],
  components: {},
  data() {
    return {
      list: [],
      form: null,
      tabType: 1,
      singState: 0,
      meetingState: 0,
      query: {
        pageNo: 1,
        pageSize: 10
      },
      accountTypeArr: ["", "余额", "零售价", "赠送额度"],
      statusCount: null
    };
  },
  created() {
    this.form = this.rowItem;
    this.calcFeeList();
    this.doQueryList();
    this.getCount();
    this.setTimeStates();
  },
  computed: {
    stateTxt() {
      let str = "";
      // 1 还未开始 2进行中 3已过期
      const {
        state,
        startTime,
        endTime,
        signUpStartTime,
        signUpEndTime
      } = this.rowItem;
      if (state === 30) {
        str = "已取消";
      } else {
        const singTime = getTimeStatus(signUpStartTime, signUpEndTime);
        const meetingTime = getTimeStatus(startTime, endTime);
        if (singTime === 1) {
          str = "未开始报名";
        } else if (singTime === 2) {
          str = "报名中";
        } else if (singTime === 3) {
          if (meetingTime === 1) {
            str = "会议未开始";
          } else if (meetingTime === 2) {
            str = "会议进行中";
          } else if (meetingTime === 2) {
            str = "会议已结束";
          }
        }
      }
      return str;
    }
  },
  methods: {
    setTimeStates() {
      const {
        state,
        startTime,
        endTime,
        signUpStartTime,
        signUpEndTime
      } = this.rowItem;

      if (state !== 30) {
        const singTime = getTimeStatus(signUpStartTime, signUpEndTime);
        const meetingTime = getTimeStatus(startTime, endTime);
        this.singState = singTime;
        this.meetingState = meetingTime;
      }
    },
    calcFeeList() {
      if (!this.form.feeList || !Array.isArray(this.form.feeList)) {
        this.form.feeList = [];
        return;
      }
      this.form.feeList.forEach(item => {
        if (item.levelId === 8 && item.type === 20) {
          item.nameStr = "普通用户";
        }
        if (item.levelId === 7 && item.type === 20) {
          item.nameStr = "体验班";
          item.typeStr = 1;
        }
        if (item.levelId === 6 && item.type === 20) {
          item.nameStr = "研修班";
          item.typeStr = 2;
        }
        if (item.levelId === 0 && item.type === 20) {
          item.nameStr = "业务线";
        }
        if (item.levelId === 0 && item.type === 30) {
          item.nameStr = "技术线";
        }
        if (item.levelId === 0 && item.type === 10) {
          item.nameStr = "内部员工";
        }
      });
    },
    /**
     * 格式化费用显示
     * @param {number} value - 费用值
     * @returns {string} 格式化后的费用或 "-"
     */
    formatFee(value) {
      if (value === null || value === undefined || value === '' || value === 0) {
        return '-';
      }
      // 如果是数字，保留两位小数
      const numValue = Number(value);
      if (isNaN(numValue)) {
        return '-';
      }
      return numValue.toFixed(2);
    },
    formateNme(type) {
      if (type === 50) {
        return '体验班';
      }
      if (type === 60) {
        return '研修班';
      }
      if (type === 40) {
        return '普通用户';
      }
      if (type === 30) {
        return '技术线';
      }
      if(type===10){
        return '内部员工';
      }
      if(type===70){
        return '儿童票';
      }
    },
    /**
     * 获取当前项在同身份组中的序号
     * @param {Object} currentItem - 当前费用项
     * @param {Number} currentIndex - 当前索引
     * @returns {Number} 在同身份组中的序号（从1开始）
     */
    getPersonOrderNumber(currentItem, currentIndex) {
      if (!this.form.feeList || !Array.isArray(this.form.feeList)) {
        return currentIndex + 1;
      }

      // 获取当前项的身份标识
      const currentIdentity = this.getItemIdentity(currentItem);
      
      // 统计前面相同身份的数量
      let sameIdentityCount = 0;
      for (let i = 0; i < currentIndex; i++) {
        const item = this.form.feeList[i];
        const itemIdentity = this.getItemIdentity(item);
        if (itemIdentity === currentIdentity) {
          sameIdentityCount++;
        }
      }
      
      // 返回序号（从1开始）
      return sameIdentityCount + 1;
    },
    /**
     * 获取费用项的身份标识
     * @param {Object} item - 费用项
     * @returns {String} 身份标识字符串
     */
    getItemIdentity(item) {
      // 使用 type 和 levelId 组合作为身份标识
      // 对于 type===20 的情况，使用 levelId 区分不同身份
      // 对于其他 type，直接使用 type 值
      if (item.type === 20) {
        return `${item.type}_${item.levelId}`;
      } else {
        return `${item.type}`;
      }
    },
    doQueryList() {
      this.query.meetingId = this.rowItem.id;
      this.query.isSignIn = true;
      this.listLoading = true;
      return meetingSignUpApi
        .fetchMeeting(this.query)
        .then(data => {
          this.list = data.data.list;
          this.total = data.data.total;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    getCount() {
      meetingSignUpApi
        .getStatusCount({ meetingId: this.rowItem.id, statuss: "20,30,80,90" })
        .then(({ data }) => {
          this.statusCount = data;
        });
    },
    getStatusClass() {
      if (this.form.state === 30) {
        return "status-cancelled";
      }
      if (this.singState === 1) {
        return "status-pending";
      } else if (this.singState === 2) {
        return "status-registering";
      } else if (this.meetingState === 1) {
        return "status-not-started";
      } else if (this.meetingState === 2) {
        return "status-ongoing";
      } else if (this.meetingState === 3) {
        return "status-ended";
      }
      return "status-default";
    },
    getFeeOrderText(index) {
      return `第${index + 1}位报名`;
    },
    getFreeIdentities() {
      // 返回免费的身份列表，这里可以根据实际业务逻辑调整
      return [{ nameStr: "体验班" }, { nameStr: "研修班" }];
    },
    handleBack() {
      this.$emit("handleShow", "", 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.app-container {
  display: flex;
  gap: 10px;
  height: 100%;
  overflow-y: auto;
  flex-direction: column;

  .meeting-info {
    display: inline-flex;
    gap: 10px;
    .meeting-header {
      display: flex;
      gap: 18px;
      padding: 10px 20px;
      border-radius: 16px;
      background-color: #ffffff;

      .main-image {
        width: 212px;
      }
      .meeting-title {
        display: flex;
        gap: 4px;
        align-items: center;
        h2 {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
          color: #000;
          line-height: 1.4;
        }
        .meeting-type {
          color: #999999;
          font-size: 13px;
          border: 1px solid #c5c5c5;
          border-radius: 4px;
          padding: 2px 4px;
        }
      }
      .meeting-meta {
        margin-top: 10px;
        .meta-item {
          margin-bottom: 10px;
          font-size: 13px;
          color: #6c6c6c;
          line-height: 20px;
          &:afrer {
            margin-bottom: 0;
          }
        }
      }
    }
    // 进度条
    .progress-section {
      display: inline-flex;
      flex: 1;
      align-items: flex-start;
      justify-content: space-between;
      padding: 20px;
      background: #ffffff;
      border-radius: 16px;
      position: relative;

      .progress-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;
        text-align: center;
        position: relative;

        .progress-dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #ddd;
          margin-bottom: 8px;
          transition: all 0.3s;
        }

        span {
          font-size: 14px;
          color: #666;
          margin-bottom: 10px;
        }

        .progress-time {
          font-size: 12px;
          color: #999;
        }

        &.active {
          .progress-dot {
            background: #5dbde7;
            box-shadow: 0 0 0 4px rgba(93, 189, 231, 0.2);
          }

          span {
            color: #5dbde7;
            font-weight: 500;
          }
        }
      }

      .progress-line {
        flex: 1;
        height: 2px;
        background: #ddd;
        margin: 0 10px;
        transition: all 0.3s;

        &.active {
          background: #5dbde7;
        }
      }
    }

    // 返回按钮
    .back-button {
      position: absolute;
      top: 20px;
      right: 20px;
      z-index: 10;
      padding: 6px 5px;
      background-color: #1596cd;
      color: #ffffff;
      border-radius: 0 16px 0 16px;
      font-size: 14px;
      cursor: pointer;
      user-select: none;
      transition: background-color 0.3s;
      white-space: nowrap;

      &:hover {
        background-color: #66b1ff;
      }

      &:active {
        background-color: #3a8ee6;
      }
    }
  }
  // 基础信息
  .info-section {
    .meeting-images {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      margin-bottom: 10px;
      .meeting-image-title {
        font-size: 14px;
        color: #2e2f3e;
      }
      .meeting-image-list {
        display: inline-flex;
        flex-wrap: wrap;
        gap: 10px;
        .meeting-image-item {
          width: 140px;
          height: 93px;
          border-radius: 8px;
          border: 1px solid #f0f0f0;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .info-content {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      justify-content: space-between;
      .info-item {
        width: 30%;
        font-size: 14px;
        color: #2e2f3e;
        line-height: 50px;
      }
    }
  }
}
// 统计信息
.stats-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 20px;
  margin-bottom: 30px;

  .stat-item {
    text-align: center;
    padding: 20px;
    background: #fff;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    transition: all 0.3s;

    &:hover {
      border-color: #5dbde7;
      box-shadow: 0 4px 12px rgba(93, 189, 231, 0.15);
    }

    .stat-number {
      font-size: 24px;
      font-weight: 600;
      color: #5dbde7;
      margin-bottom: 8px;
    }

    .stat-label {
      font-size: 14px;
      color: #666;
    }
  }
}

// 标签页
.tab-box {
  margin-bottom: 30px;
  border-bottom: 1px solid #f0f0f0;

  span {
    display: inline-block;
    padding: 12px 24px;
    font-size: 16px;
    color: #666;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    transition: all 0.3s;

    &.active {
      color: #5dbde7;
      border-bottom-color: #5dbde7;
    }

    &:hover {
      color: #5dbde7;
    }
  }
}
.section-box {
  border-radius: 16px;
  background-color: #ffffff;

  // 通用区块样式
  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #000000;
    padding: 20px;
    border-bottom: 1px solid #e5e5e5;
  }
  .section-body {
    padding: 20px;
  }
}
// 报名身份/费用限制
.detail-section {
  .participation-layout {
    display: flex;
    align-items: flex-start;
    gap: 20px;

    .participation-label {
      color: #666;
      font-size: 14px;
      min-width: 100px;
      flex-shrink: 0;
    }

    .participation-content {
      flex: 1;
      .participation-type {
        padding-bottom: 20px;
      }
    }
  }

  .identity-list {
    margin-bottom: 20px;

    .identity-item {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      font-size: 14px;

      .identity-name {
        color: #333;
        margin-right: 8px;
        min-width: 80px;
      }

      .identity-status {
        color: #333;
        font-weight: 500;
      }
    }
  }

  .fee-table {
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    overflow: hidden;

    .table-header {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
      background: #f8f9fa;
      border-bottom: 1px solid #f0f0f0;

      .header-cell {
        padding: 12px;
        font-size: 14px;
        font-weight: 600;
        color: #333;
        text-align: center;
        border-right: 1px solid #f0f0f0;

        &:last-child {
          border-right: none;
        }
      }
    }

    .table-row {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
      border-bottom: 1px solid #f0f0f0;

      &:last-child {
        border-bottom: none;
      }

      .table-cell {
        padding: 12px;
        font-size: 14px;
        color: #333;
        text-align: center;
        border-right: 1px solid #f0f0f0;

        &:last-child {
          border-right: none;
        }
      }
    }
  }
}

// 会议详情
.content-section {
  margin-bottom: 30px;

  .content-body {
    padding: 20px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #f0f0f0;
    min-height: 100px;

    ::v-deep {
      p,
      div,
      span {
        line-height: 1.6;
        color: #333;
      }
    }
  }
}

// 主讲老师和创建人
.lecturer-section,
.creator-section {
  margin-bottom: 30px;

  .lecturer-info,
  .creator-info {
    display: flex;
    align-items: center;
    padding: 20px;
    background: #fff;
    border: 1px solid #f0f0f0;
    border-radius: 8px;

    .lecturer-avatar,
    .creator-avatar {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background: #5dbde7;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 20px;

      i {
        font-size: 24px;
        color: #fff;
      }
    }

    .lecturer-details,
    .creator-details {
      flex: 1;

      .lecturer-name,
      .creator-name {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        margin-bottom: 8px;
      }

      .lecturer-level,
      .creator-level {
        font-size: 14px;
        color: #666;
        margin-bottom: 4px;
      }

      .lecturer-phone,
      .creator-phone {
        font-size: 14px;
        color: #5dbde7;
      }
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .meeting-info {
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .meeting-header {
    flex-direction: column;
    align-items: flex-start;

    .meeting-title {
      margin: 20px 0;
    }

    .meeting-meta {
      flex-direction: column;
      gap: 10px;
    }
  }

  .progress-section {
    flex-direction: column;
    gap: 20px;

    .progress-line {
      display: none;
    }
  }

  .stats-section {
    grid-template-columns: repeat(2, 1fr);
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .image-gallery {
    flex-direction: column;
  }
}

// 签到名单
.signin-stats {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;

  .stat-item {
    flex: 1;
    text-align: center;
    padding: 20px;
    background: #fff;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    transition: all 0.3s;

    &:hover {
      border-color: #5dbde7;
      box-shadow: 0 4px 12px rgba(93, 189, 231, 0.15);
    }

    .stat-number {
      font-size: 24px;
      font-weight: 600;
      color: #5dbde7;
      margin-bottom: 8px;
    }

    .stat-label {
      font-size: 14px;
      color: #666;
    }
  }
}

.signin-table {
  margin-bottom: 20px;
}
</style>
